import React, { Children } from 'react'
import '../../../assets/scss/components/Shared/AccordianDropdownList/accordian-dropdown-list.css'

//component responsible for the dropdown functionality (must wrap it with <ul> in parent component)
//expects list header, list content, context and current active index for toggle dropdown


const AccordianDropDownList = ({listHead,listData, context, activeIndex, isDisable}) => {
    const {activeKeyList,setActiveKeyList} = React.useContext(context)
    const handleToggleDropdown = (index) => {
        setActiveKeyList(prev=>Array.from(prev,(val,ind)=> ind === index? !val:val))
    }


    return (
        <React.Fragment>
            <li className='AccordianDropdown-listItem'>
                <div onClick={()=>handleToggleDropdown(activeIndex)}>{listHead}</div>
                {!isDisable && 
                    <div className={`AccordianDropdown-listContent_${!activeKeyList[activeIndex]? 'collapse':'active'}`}>
                        {activeKeyList[activeIndex] && listData}
                    </div>
                }
                
            </li> 
        </React.Fragment>
    )
}

export default AccordianDropDownList